import React from "react";
import { Box, Typography, Divider, Link } from "@mui/material";
import Header from "@/layouts/Header/Header";

const TermsOfService = () => {
  const terms = [
    {
      title: "1. Who We Are",
      content: [
        "Home Buying Network (HBN-Tech) is a platform that connects home buyers with mortgage brokers, conveyancers, building inspectors, and other real estate professionals (“Pros”).",
        "We are not a licensed real estate, legal, or financial services provider.",
      ],
    },
    {
      title: "2. Using Our Platform",
      content: [
        "You must be at least 18 years old to use HBN.",
        "You agree to provide accurate, truthful, and complete information when creating a profile or interacting on the platform.",
        "We reserve the right to approve, modify, suspend, or remove any user profile or content at our discretion.",
      ],
    },
    {
      title: "3. Professional Listings",
      content: [
        "Professionals listed on HBN are solely responsible for the accuracy of their profiles and the services they offer.",
        "Some professional profiles may be created using publicly available information. Professionals may request to claim or edit their profile.",
        "Verification badges (if any) do not constitute endorsement or guarantee of service quality.",
      ],
    },
    {
      title: "4. User Conduct",
      content: [
        "You agree not to:",
        "• Use HBN for any unlawful or misleading activity",
        "• Post or transmit harmful, fraudulent, or abusive content",
        "• Impersonate another person or professional",
        "• Attempt to damage or disrupt the platform",
      ],
    },
    {
      title: "5. Payments (If Applicable)",
      content: [
        "Access to some features may require payment. These terms will be clearly outlined before any transaction occurs.",
        "We reserve the right to introduce or adjust pricing and subscription models with prior notice.",
      ],
    },
    {
      title: "6. Disclaimers",
      content: [
        "HBN acts as a connector between home buyers and professionals but is not liable for services delivered or not delivered by any third party.",
        "We do not guarantee the availability, reliability, or quality of any listed professional.",
      ],
    },
    {
      title: "7. Limitation of Liability",
      content: [
        "To the maximum extent permitted by law, Home Buying Network will not be liable for any indirect, incidental, special, or consequential damages arising from your use of the platform.",
      ],
    },
    {
      title: "8. Privacy",
      content: [
        "Please refer to our Privacy Policy to understand how we collect, use, and protect your data.",
        "Privacy Policy: https://hbn-tech.com/privacy-policy",
      ],
    },
    {
      title: "9. Changes to These Terms",
      content: [
        "We may update these Terms from time to time. By continuing to use HBN after changes are posted, you agree to the updated terms.",
      ],
    },
    {
      title: "10. Contact Us",
      content: [
        "If you have questions or concerns, please contact us at:",
        "hello@hbn-tech.com",
      ],
    },
  ];

  return (
    <>
    <Header />
    <Box
      sx={{
        position: "fixed",
        top: 64,
        left: 0,
        right: 0,
        bottom: 0,
        overflowY: "auto",
        px: { xs: 2, sm: 4, md: 8 },
        py: 4,
        backgroundColor: "#fff",
      }}
    >
      <Typography variant="h4" fontWeight="bold" gutterBottom>
        Terms of Service
      </Typography>
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        Last updated: 09/06/2025
      </Typography>

      <Divider sx={{ my: 2 }} />

      {terms.map((section, index) => (
        <Box key={index} mb={3}>
          <Typography variant="h6" fontWeight="bold" gutterBottom>
            {section.title}
          </Typography>
          {section.content.map((line, i) => {
            // Detect and render link if present
            if (line.includes("https://")) {
              return (
                <Typography variant="body2" paragraph key={i}>
                  <Link href={line} target="_blank" rel="noopener">
                    {line}
                  </Link>
                </Typography>
              );
            }
            return (
              <Typography variant="body2" paragraph key={i}>
                {line}
              </Typography>
            );
          })}
        </Box>
      ))}
    </Box>
    </>
  );
};

export default TermsOfService;
